export default __webpack_public_path__ + "static/media/gb-eng.ebbd69ac.svg";